import "../../styles/HomePage/Home.css";
import {
  HOME_VIDEO,
  HOME_VIDEO_HEADER_1,
  HOME_VIDEO_HEADER_2,
  HOME_VIDEO_HEADER_3,
  HOME_VIDEO_BUTTON_TEXT,
} from "../../constants";
// import SoundToggle from "../SoundToggle";
import { useSelector } from "react-redux";
import { selectIsSoundOn } from "../../state/slices";
import useDeviceType from "../../hooks/useDeviceType";

function Home() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "720px",
        width: "100vw",
        overflow: "hidden",
        margin: "0px 0px 0px 0px",
      }}
    >
      <BackgroundVideo />
      <VideoOverlay />
      {/* <SoundToggle /> */}
    </div>
  );
}

function BackgroundVideo() {
  const isSoundOn = useSelector(selectIsSoundOn);
  return (
    <video
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
      playsinline="playsinline"
      autoplay="autoplay"
      loop="loop"
      muted={!isSoundOn}
      preload="metadata"
      // poster={HOME_VIDEO_THUMB}
    >
      <source src={HOME_VIDEO} type="video/mp4" />
      {/* <img src={HOME_VIDEO_THUMB} /> */}
    </video>
  );
}

function VideoOverlay() {
  const { reValue2 } = useDeviceType();
  return (
    <div
      style={{
        backgroundColor: "rgba(4, 1, 1, 0.5)",
        position: "absolute",
        left: "0",
        color: "white",
        height: "720px",
        width: "100vw",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "end",
        margin: "0px 0px 0px 0px",
        padding: reValue2({
          desktop: "0px 0px 80px 0px",
          tablet: "0px 0px 80px 0px",
          mobile: "0px 0px 25px 0px",
        }),
      }}
    >
      <VideoOverlayInnerContent />
    </div>
  );
}

function VideoOverlayInnerContent() {
  const { reValue2 } = useDeviceType();
  return (
    <div
      style={{
        width: reValue2({
          desktop: "90%",
          tablet: "80%",
          mobile: "91%",
        }),
        display: "flex",
        flexDirection: "column",
        bottom: "0",
        left: "0",
      }}
    >
      <VideoHeader1 />
      <VideoHeader2 />
      <VideoSubText />
      <HomeVideoButton />
    </div>
  );
}

function HomeVideoButton() {
  const { reValue2 } = useDeviceType();
  return (
    <button
      style={{
        backgroundColor: "#a7d8f7",
        color: "black",
        padding: "10px 20px",
        borderRadius: "10px",
        border: "none",
        cursor: "pointer",
        fontSize: "15px",
        fontWeight: "bold",
        height: "55px",
        width: reValue2({
          desktop: "270px",
          tablet: "270px",
          mobile: "100%",
        }),
        margin: "35px 25px 0px 0px",
      }}
      onClick={homeVideoButtonOnClick}
    >
      {HOME_VIDEO_BUTTON_TEXT}
    </button>
  );
}

function homeVideoButtonOnClick() {
  const element = document.querySelector(".consultation-form-main-column");
  if (element) {
    const navbarHeight = 150; // Adjust according to your navbar height
    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: elementPosition - navbarHeight,
      behavior: "smooth",
    });
  }
}

function VideoHeader1() {
  const { reValue2 } = useDeviceType();
  return (
    <span
      style={{
        color: "white",
        fontSize: reValue2({
          desktop: "73px",
          tablet: "48px",
          mobile: "33px",
        }),
        fontWeight: "bold",
      }}
    >
      {HOME_VIDEO_HEADER_1}
    </span>
  );
}

function VideoHeader2() {
  const { isDesktop, reValue2 } = useDeviceType();
  return (
    <span
      style={{
        color: "#a7d8f7",
        fontSize: reValue2({
          desktop: "73px",
          tablet: "48px",
          mobile: "33px",
        }),
        fontWeight: "bold",
        lineHeight: isDesktop ? "70px" : "35px",
      }}
    >
      {HOME_VIDEO_HEADER_2}
    </span>
  );
}

function VideoSubText() {
  const { reValue2 } = useDeviceType();
  return (
    <div
      style={{
        color: "white",
        fontSize: "15px",
        fontWeight: "bold",
        width: reValue2({
          desktop: "840px",
          tablet: "100%",
          mobile: "85vw",
        }),
        margin: "25px 0px 0px 0px",
      }}
    >
      {HOME_VIDEO_HEADER_3}
    </div>
  );
}

export default Home;
